import { defineMessages } from "react-intl";

export const cegidInvoiceDialogMessages = defineMessages({
  title: {
    defaultMessage: "Generate CEGID invoice",
    id: "oYSjEC",
    description: "dialog header",
  },
  reviewTitle: {
    defaultMessage: "Review CEGID draft",
    id: "EqRIBm",
    description: "cegid invoice dialog header, draft review step",
  },
  documentTypeLabel: {
    defaultMessage: "Document type",
    id: "Gyz23m",
    description: "cegid invoice dialog, field label",
  },
  documentTypeFt: {
    defaultMessage: "FT — Fatura",
    id: "5QDTRi",
    description: "cegid invoice dialog, document type option",
  },
  documentTypeFr: {
    defaultMessage: "FR — Fatura-recibo",
    id: "p9yxc+",
    description: "cegid invoice dialog, document type option",
  },
  paymentMechanismLabel: {
    defaultMessage: "Payment method",
    id: "eUG1e8",
    description: "cegid invoice dialog, FR payment method field label",
  },
  paymentCC: {
    defaultMessage: "CC — Credit card",
    id: "EvxWCG",
    description: "cegid payment method option",
  },
  paymentDC: {
    defaultMessage: "DC — Debit card",
    id: "0Rzwai",
    description: "cegid payment method option",
  },
  paymentMB: {
    defaultMessage: "MB — Multibanco",
    id: "VemA6I",
    description: "cegid payment method option",
  },
  paymentTR: {
    defaultMessage: "TR — Bank transfer",
    id: "Kn5vkP",
    description: "cegid payment method option",
  },
  paymentDE: {
    defaultMessage: "DE — E-money (e.g. MB WAY)",
    id: "iaXSij",
    description: "cegid payment method option",
  },
  paymentMO: {
    defaultMessage: "MO — Cash",
    id: "HcVqDZ",
    description: "cegid payment method option",
  },
  paymentOU: {
    defaultMessage: "OU — Other",
    id: "QVN//E",
    description: "cegid payment method option",
  },
  orderPaid: {
    defaultMessage: "Order fully paid · {total}",
    id: "CZdxwV",
    description: "cegid invoice dialog, payment status pill",
  },
  orderNotPaid: {
    defaultMessage: "Order NOT fully paid · {total}",
    id: "weMiOU",
    description: "cegid invoice dialog, payment status pill",
  },
  frNeedsPaid: {
    defaultMessage: "A fatura-recibo (FR) can only be issued for a fully paid order.",
    id: "B34Bcg",
    description: "cegid invoice dialog, warning",
  },
  nifLabel: {
    defaultMessage: "Customer NIF",
    id: "d30jsw",
    description: "cegid invoice dialog, field label",
  },
  nifHelperText: {
    defaultMessage: "Leave blank to invoice as final consumer (999999990).",
    id: "kfosSF",
    description: "cegid invoice dialog, field helper text",
  },
  customerFromCegid: {
    defaultMessage: "From CEGID: {address}",
    id: "ATYo8C",
    description: "cegid invoice dialog, customer name helper when CEGID knows the NIF",
  },
  customerNotInCegid: {
    defaultMessage:
      "This NIF has no customer record in CEGID yet — it is created with this name and the order's billing address.",
    id: "iI/+cd",
    description: "cegid invoice dialog, customer name helper when CEGID doesn't know the NIF",
  },
  customerLookupLoading: {
    defaultMessage: "Looking the NIF up in CEGID…",
    id: "Ep2ier",
    description: "cegid invoice dialog, customer name helper while looking up the NIF",
  },
  shippingBilledAtOrderCost: {
    defaultMessage: "Billed at the order's shipping cost: {price} incl. VAT.",
    id: "O3+sB+",
    description: "cegid invoice dialog, shipping line price note",
  },
  referenceRememberedForVariant: {
    defaultMessage: "SKU and name are saved for this variant's next invoices.",
    id: "DQeQbu",
    description: "cegid invoice dialog, line helper text: mapping is remembered per variant",
  },
  referenceRememberedForProduct: {
    defaultMessage: "SKU and name are saved for every variant of this product's next invoices.",
    id: "Cu3Lyh",
    description: "cegid invoice dialog, line helper text: mapping is remembered per product",
  },
  customerNameLabel: {
    defaultMessage: "Customer name",
    id: "XABpsD",
    description: "cegid invoice dialog, field label",
  },
  linesHeader: {
    defaultMessage: "Lines",
    id: "zoHY5s",
    description: "cegid invoice dialog, section header",
  },
  shippingLineLabel: {
    defaultMessage: "Shipping",
    id: "sTdZ2K",
    description: "cegid invoice dialog, line label for the shipping line",
  },
  shippingUsesCegidName: {
    defaultMessage: "Billed under its CEGID name.",
    id: "58YTZ/",
    description: "cegid invoice dialog, shipping line hint",
  },
  itemCodeLabel: {
    defaultMessage: "CEGID SKU",
    id: "xWPkDj",
    description: "cegid invoice dialog, field label",
  },
  itemDescriptionLabel: {
    defaultMessage: "CEGID name",
    id: "scpVoG",
    description: "cegid invoice dialog, field label",
  },
  applyToWholeProduct: {
    defaultMessage: "Apply to all variants of this product",
    id: "6vrbYq",
    description: "cegid invoice dialog, checkbox label",
  },
  existsInCegid: {
    defaultMessage: "Already in CEGID",
    id: "oIkqK5",
    description: "cegid invoice dialog, line status badge",
  },
  notInCegid: {
    defaultMessage: "Not in CEGID",
    id: "jIc8If",
    description: "cegid invoice dialog, line status badge",
  },
  createInCegid: {
    defaultMessage: "Create it in CEGID with this SKU and name",
    id: "8cXXnS",
    description: "cegid invoice dialog, checkbox label",
  },
  shippingNotInCegid: {
    defaultMessage: "Shipping SKU not found in CEGID — fix it in the CEGID plugin settings.",
    id: "Z1SSkd",
    description: "cegid invoice dialog, shipping line error",
  },
  discountBadge: {
    defaultMessage: "{percentage}% off",
    id: "U1yerY",
    description: "cegid invoice dialog, per-line discount badge",
  },
  linePrice: {
    defaultMessage: "{unitPrice} incl. VAT · VAT {tax}",
    id: "IW1VMZ",
    description: "cegid invoice dialog, line price summary",
  },
  createDraft: {
    defaultMessage: "Create draft in CEGID",
    id: "hlwlf/",
    description: "cegid invoice dialog, button",
  },
  createDraftHint: {
    defaultMessage:
      "This only creates a draft in CEGID. Nothing is final until you review it and click “Finalize invoice”.",
    id: "G4vEf0",
    description: "cegid invoice dialog, hint under the edit step",
  },
  draftBanner: {
    defaultMessage:
      "This is a DRAFT in CEGID (id {documentId}) — not an invoice yet. Below is what CEGID will issue, read back from CEGID.",
    id: "D4FfpU",
    description: "cegid draft review, banner",
  },
  customer: {
    defaultMessage: "Customer",
    id: "O60UCq",
    description: "cegid draft review, section label",
  },
  mergeSelected: {
    defaultMessage: "Merge selected ({count})",
    id: "hYxMIb",
    description: "cegid invoice dialog, button merging the selected lines",
  },
  mergeHint: {
    defaultMessage:
      "Tick lines to bill them as one invoice line. Lines with the same CEGID SKU, price and VAT are merged automatically; the SKU is saved, so they merge the same way on the next invoices.",
    id: "g8k2fo",
    description: "cegid invoice dialog, hint above the lines",
  },
  mergeAutoHint: {
    defaultMessage:
      "Lines with the same CEGID SKU, price and VAT are merged automatically; the SKU is saved, so they merge the same way on the next invoices.",
    id: "diCUKA",
    description: "cegid invoice dialog, hint above the lines when nothing else can be merged",
  },
  selectLine: {
    defaultMessage: "Select line",
    id: "LqTyfS",
    description: "cegid invoice dialog, line selection checkbox label",
  },
  mergedLinesTitle: {
    defaultMessage: "{count} merged lines · {quantity} units",
    id: "cyjIjd",
    description: "cegid invoice dialog, title of a merged line group",
  },
  mergedMember: {
    defaultMessage: "{quantity}× {name} · {unitPrice} incl. VAT",
    id: "Kfv6ld",
    description: "cegid invoice dialog, one order line inside a merged group",
  },
  mergedSplitByPrice: {
    defaultMessage: "Billed as {count} invoice lines, one per price and VAT rate.",
    id: "R5cnBX",
    description: "cegid invoice dialog, merged group with different prices",
  },
  unmerge: {
    defaultMessage: "Unmerge",
    id: "dkNE5Z",
    description: "cegid invoice dialog, button splitting a merged group",
  },
  extraTextLabel: {
    defaultMessage: "Extra text (this invoice only)",
    id: "Txg4bQ",
    description: "cegid invoice dialog, per-line field label",
  },
  extraTextHelper: {
    defaultMessage: "Appended to the line name on this invoice. Not saved.",
    id: "0VEfEI",
    description: "cegid invoice dialog, per-line field helper text",
  },
  cegidCatalogPrice: {
    defaultMessage: "CEGID product price: {price} — this invoice uses the order price.",
    id: "EQMlBU",
    description: "cegid invoice dialog, shown when the CEGID product price differs",
  },
  colSku: {
    defaultMessage: "SKU",
    id: "Ia4fi3",
    description: "cegid draft review, column",
  },
  colDescription: {
    defaultMessage: "Description",
    id: "jgXfn2",
    description: "cegid draft review, column",
  },
  colQuantity: {
    defaultMessage: "Qty",
    id: "EX3U1f",
    description: "cegid draft review, column",
  },
  colUnitPrice: {
    defaultMessage: "Unit price incl. VAT",
    id: "Pgg/Jo",
    description: "cegid draft review, column",
  },
  colVat: {
    defaultMessage: "VAT",
    id: "Tngwxm",
    description: "cegid draft review, column",
  },
  colTotal: {
    defaultMessage: "Total",
    id: "djiyBi",
    description: "cegid draft review, column",
  },
  expected: {
    defaultMessage: "order: {value}",
    id: "hneRh2",
    description: "cegid draft review, expected value shown under a mismatching cell",
  },
  cegidTotal: {
    defaultMessage: "CEGID total",
    id: "6Js0RJ",
    description: "cegid draft review, totals label",
  },
  cegidReportedTotal: {
    defaultMessage: "CEGID document total",
    id: "f5wub4",
    description: "cegid draft review, totals label",
  },
  orderTotal: {
    defaultMessage: "Order total",
    id: "f8caip",
    description: "cegid draft review, totals label",
  },
  problemsHeader: {
    defaultMessage: "Can't finalize — the draft doesn't match the order:",
    id: "tQrDVi",
    description: "cegid draft review, problems header",
  },
  allChecksPassed: {
    defaultMessage: "All checks passed: lines, VAT rates, customer and totals match the order.",
    id: "X9nuqU",
    description: "cegid draft review, success message",
  },
  openDraftPdf: {
    defaultMessage: "Open draft PDF in CEGID",
    id: "OD9fUB",
    description: "cegid draft review, link",
  },
  reviewedConfirmation: {
    defaultMessage:
      "I reviewed this draft and confirm it is correct. Finalizing issues a legal invoice that can't be edited or deleted.",
    id: "0dImpN",
    description: "cegid draft review, confirmation checkbox",
  },
  finalize: {
    defaultMessage: "Finalize invoice",
    id: "pLsaW3",
    description: "cegid draft review, button",
  },
  discardDraft: {
    defaultMessage: "Discard draft",
    id: "cZMQP0",
    description: "cegid draft review, button",
  },
  close: {
    defaultMessage: "Close (keep draft)",
    id: "YdNL/v",
    description: "cegid draft review, button",
  },
  notConfigured: {
    defaultMessage: "CEGID isn't configured yet. Set it up under Extensions > CEGID Cloudware.",
    id: "GudXAB",
    description: "cegid invoice dialog, error state",
  },
});

export const cegidInvoicePdfMessages = defineMessages({
  print: {
    defaultMessage: "Print",
    id: "5XQk8e",
    description: "order invoice list, print the invoice PDF",
  },
  download: {
    defaultMessage: "Download",
    id: "NsCPa+",
    description: "order invoice list, download the invoice PDF",
  },
  pdfError: {
    defaultMessage: "Could not get the invoice PDF",
    id: "AFAqY8",
    description: "order invoice list, error notification title",
  },
  pdfUnavailable: {
    defaultMessage: "The invoice PDF is not available.",
    id: "Fs/ufA",
    description: "order invoice list, error notification text",
  },
});
